import { CommitmentTypes } from 'legacy/lut/components/widgets/public/partner360/commitment/models'
import { getCrudCommitment } from 'legacy/lut/services/partner360/commitment/helpers/getCrudCommitment'

import { IForm } from 'core-components/classes/models/IForm'

export const reloadSign = (item: IForm) => {
  if (item.CommitmentType === CommitmentTypes.Partner) {
    getCrudCommitment().removeQueries(true)
  }
}
